module.exports = __webpack_public_path__ + "img/icon-34.e7e526a5.svg";